import React, { useEffect, useState } from 'react'
import "./style.css"
import { Block, CRIcon, Inline } from '../../crRender'
import { useTranslation } from 'react-i18next'

const Checkbox = ({ isDisabled = false, onApply, value = false, label }) => {

    const [isChecked, setIsChecked] = useState(value)
    const { t } = useTranslation()

    const handleChecked = () => {
        if (!!isDisabled) return
        setIsChecked(prev => !prev)
        onApply()
    }


    useEffect(() => {
        setIsChecked(value)
    }, [value])

    return (
        <div className='check-box-conatiner' onClick={handleChecked}>
            <Block className={`${isDisabled ? 'disabled' : ""} ${isChecked ? 'selected-card' : ""} select-card`}>
                <CRIcon isRender={isChecked} icon={'fluent:checkmark-12-filled'} />
            </Block>
            <Inline className={"checkbox-label"} isRender={label}>
                {t(label)}
            </Inline>
        </div>
    )
}

export default Checkbox
